import type { Training } from "@/services/api/types";
import * as Styled from "./styled";
import Stopwatch from "@assets/icons/stopwatch-icon.svg?react";
import Chevron from "@assets/icons/arrow-down.svg?react";
import LoadingScreen from "@/components/shared-ui/LoadingScreen";
import Card from "@/components/shared-ui/Card";
import ReactPlayer from "react-player/youtube";
import ContactCard from "@/components/shared-ui/ContactCard";

export type Props = {
  title: string;
  training?: Training[];
  videoSlug?: string;
  pageSlug: string;
};

const TrainingLayout = ({ training, title, videoSlug, pageSlug }: Props) => {
  const currentTrainingSection = training?.find((item) =>
    item.videos.find((video) => videoSlug === video.slug)
  );

  const currentVideo = currentTrainingSection?.videos.find(
    (video) => videoSlug === video.slug
  );

  if (!training || !currentTrainingSection || !currentVideo) {
    return <LoadingScreen withoutPage />;
  }

  return (
    <Styled.Training>
      <Styled.SidebarCard>
        <Styled.Title>{title}</Styled.Title>
        {training.map((item) => (
          <Styled.SidebarSection
            key={item.id}
            $active={currentTrainingSection.id === item.id}
          >
            <Styled.SidebarHeadingLink
              to={`/${pageSlug}/${item.videos[0].slug}`}
            >
              <Styled.SidebarHeading>{item.title}</Styled.SidebarHeading>
              <Chevron />
            </Styled.SidebarHeadingLink>
            <Styled.SidebarSubSection>
              {item.videos.map((video) => (
                <Styled.SidebarItem
                  key={video.slug}
                  $active={
                    currentTrainingSection.id === item.id &&
                    currentVideo?.title === video.title
                  }
                  to={`/${pageSlug}/${video.slug}`}
                >
                  {video.title}
                  <Styled.Duration>
                    <Stopwatch /> {video.duration}
                  </Styled.Duration>
                </Styled.SidebarItem>
              ))}
            </Styled.SidebarSubSection>
          </Styled.SidebarSection>
        ))}
      </Styled.SidebarCard>
      <Card noPadding gridColumn={[1, 2]}>
        <Styled.VideoCard>
          <Styled.VideoWrapper>
            <ReactPlayer
              url={currentVideo.youtubeUrl}
              className="react-player"
              width="100%"
              height="100%"
              controls={true}
              config={{ playerVars: { color: "white" } }}
            />
          </Styled.VideoWrapper>
          <Styled.Title>{currentVideo.title}</Styled.Title>
          <p>{currentVideo.description}</p>
        </Styled.VideoCard>
      </Card>
      <ContactCard />
    </Styled.Training>
  );
};

export default TrainingLayout;
